import heroimg from "../../../../../images/LandingPageImage/mn_template_creation.webp";
import "../../styles/LandingPageCss/MainHomeSection.css";
import FAQContactSection from "../LandingPagecomponents/FAQContactSection";
import google from "../../../../../images/LandingPageImage/google.png";

import { useModal } from "../../../../../MyContext";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";

export default function PersonalizedMessages() {
  const { openModal } = useModal();

  return (
    <div>
      <Navbar />
      <section className="hero-section py-5 py-md-5 font-inter">
        <div className="container px-3 px-lg-4">
          <div className="row align-items-center gx-lg-5 gy-5">
            <div className="col-12 col-md-6 order-2 order-md-1">
              <div className="hero-content text-center text-md-start">
                <h1 className="hero-title text-purple font-spacegrotesk fw-semibold">
                  Customized Messages: Forge More Intimate Customer
                  Relationships on WhatsApp
                </h1>

                <p className="hero-subtitle mt-3">
                  The modern competitive digital environment makes customers
                  seek more than some generic promotions. They desire more of a
                  purposeful communication that appeals directly to them.
                  Whatsapp campaigns are now based on personalized messages,
                  which enable businesses to attract customers with timely and
                  relevant messages that are personalized.
                </p>

                <div className="d-flex gap-3 mt-4 justify-content-center justify-content-lg-start flex-wrap">
                  <Link
                    to="/login"
                    className="btn d-flex align-items-center text-decoration-none bg-neon-purple rounded-1 text-white justify-content-center gap-2 home-btn-primary fw-medium hover-scale"
                  >
                    <span
                      className="rounded-circle bg-white d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{ width: "30px", height: "30px" }}
                    >
                      <img
                        src={google}
                        alt="Google"
                        style={{ width: "20px", height: "20px" }}
                        className="img-fluid"
                      />
                    </span>

                    <span className="text-nowrap fs-6">Start With Google</span>
                  </Link>
                  <button
                    onClick={openModal}
                    className="btn d-flex align-items-center justify-content-center bg-white rounded-1   home-btn-secondary fw-medium"
                  >
                    <span className="text-nowrap fs-5">Book a Demo</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 order-2 order-md-2">
              <div className="hero-image-wrapper d-flex justify-content-center align-items-center">
                <div className="hero-circle-bg">
                  <div className="circle-element "></div>
                  <img
                    src={heroimg}
                    alt="WhatsApp marketing dashboard"
                    className="hero-img img-fluid  rounded-4"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-section font-inter text-center text-white d-flex align-items-center">
        <div className="container">
          <h1 className="new-section-title font-spacegrotesk">
            What Are the Personalized Messages in
            <br />
            WhatsApp Marketing?
          </h1>

          <p className="about-text text-dark mb-5">
            Personal messages are customized messages that are delivered to
            customers according to their preferences and behavior, purchase
            history or the stage of interaction. Businesses tailor their content
            using customer names, interests, order details or location, instead
            of sending one message to everybody.
          </p>

          <div className="row g-4 justify-content-center">
            <div className="col-md-6">
              <div className="info-card text-start vision-card">
                <h3 className="text-dark font-spacegrotesk">
                  The importance of Personalized Messages to Businesses
                </h3>
                <p>
                  Personalized WhatsApp messages drive higher engagement by
                  delivering relevant content that customers are more likely to
                  open, read, and respond to. This approach improves customer
                  satisfaction, strengthens brand loyalty, and increases
                  conversions while reducing opt-outs.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="info-card text-start  mission-card">
                <h3 className="font-spacegrotesk text-dark">
                  The Way MsgNotifier Sends Customized Messages on a Large Scale
                </h3>
                <p>
                  MsgNotifier is an all-in-one platform designed to help
                  businesses deliver highly personalized WhatsApp marketing at
                  scale. With our intuitive WhatsApp marketing tool, brands can
                  customize messages, target audiences based on behavior,
                  automate follow-ups, and track engagement without any
                  technical setup.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-section font-inter text-center text-white d-flex align-items-center">
        <div className="container">
          <h1 className="new-section-title font-spacegrotesk">
            Individualized Messages to Various
            <br />
            Objectives of Business
          </h1>

          <p className="about-text text-dark mb-5">
            Individualized WhatsApp messages help businesses align communication
            with specific objectives such as lead generation, customer
            engagement, sales, and support. By tailoring messages to user
            behavior and intent, brands can deliver relevant conversations that
            drive better responses and measurable outcomes.
          </p>

          <div className="row g-4 justify-content-center">
            <div className="col-md-4">
              <div className="info-card bg-lavender text-start vision-card">
                <h3 className="text-dark font-spacegrotesk">
                  Sales & Promotions
                </h3>
                <p>
                  Deliver personalized offers depending on customer preferences
                  or past shopping. One-on-one marketing is more effective than
                  mass communications, and it leads to a higher ilevel of
                  conversion.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="info-card text-start bg-adonis  ">
                <h3 className="font-spacegrotesk text-dark">
                  Customer Service and Communication
                </h3>
                <p>
                  Personalized messages should be used to notify them with
                  orders, deliveries, and service reminders. This would improve
                  the customer experience by promoting the business using
                  whatsapp.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="info-card text-start bg-coral  mission-card">
                <h3 className="font-spacegrotesk text-dark">Lead Nurturing</h3>
                <p>
                  This is the practice of targeting prospects with customized
                  content at each sales funnel level. Being a results driven
                  whatsapp marketing company, MsgNotifier assists businesses to
                  nurture leads to a greater extent.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section font-inter text-center text-white d-flex align-items-center">
        <div className="container">
          <h1 className="new-section-title font-spacegrotesk">
            Why MsgNotifier to use in Personalized
            <br />
            WhatsApp Marketing?
          </h1>

          <p className="about-text text-dark mb-5">
            MsgNotifier is one of the credible whatsapp marketing firms
            dedicated to the provision of value-based communication. Our
            platform is designed in a way that it can be scaled to
            personalization and at the same time compliance and high delivery
            rates.
          </p>

          <div className="row g-4 justify-content-center">
            <div className="col-md-4">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Lead Generation with Personalized Outreach
                </h3>
                <p className="text-white">
                  Tailored WhatsApp messages help attract potential customers by
                  addressing their specific interests and needs. Personalized
                  lead messages improve response rates and initiate meaningful
                  conversations from the first interaction.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Customer Engagement Through Relevant Messaging
                </h3>
                <p className="text-white">
                  By sending content aligned with user behavior and preferences,
                  businesses can keep customers actively engaged. Relevant
                  messages feel less promotional and more conversational,
                  encouraging ongoing interaction
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Sales Conversion with Targeted Offers
                </h3>
                <p className="text-white">
                  Personalized recommendations, discounts, and product updates
                  guide customers through the buying journey. This targeted
                  approach increases purchase intent and drives higher
                  conversion rates.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Customer Support and Service Automation
                </h3>
                <p className="text-white">
                  Individualized messages enable faster issue resolution through
                  automated yet personal responses. Businesses can share
                  updates, reminders, and support information without losing the
                  human touch.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Retention and Loyalty Building
                </h3>
                <p className="text-white">
                  Customized follow-ups and exclusive offers help strengthen
                  long-term customer relationships. Consistent, personalized
                  communication increases brand loyalty and repeat business.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="info-card bg-purple text-start vision-card">
                <h3 className="text-white font-spacegrotesk">
                  Campaign Performance Optimization
                </h3>
                <p className="text-white">
                  Personalized messaging allows businesses to track engagement
                  and refine communication strategies. By analyzing responses
                  and behavior, brands can continuously improve message
                  relevance and campaign results.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FAQContactSection />
      <Footer />
    </div>
  );
}
